import { Action } from '@ngrx/store';

import { OrganisationActions, OrganisationActionTypes } from '@actions/organisation.actions';
import { FetchFromLocalStorage } from '@common/helpers/fetch-from-local-storage.helper';

import { OrganisationState } from 'state';

const emptyState: OrganisationState = {
    organisation: {
        Id: '',
        ExternalId: '',
        Name: '',
        LongName: '',
        ApplicationScope: ''
    }
};

export const initialState: OrganisationState = FetchFromLocalStorage('organisation') || emptyState;

export function organisationReducer(state = initialState, action: Action): OrganisationState {
    const organisationAction: OrganisationActions = action as OrganisationActions;

    switch (organisationAction.type) {
        case OrganisationActionTypes.Set:
            return { ...state, organisation: organisationAction.payload };
        case OrganisationActionTypes.Unset:
            return { ...emptyState };
        default:
            return state;
    }
}
